import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 relative h-[300px] md:h-[450px] overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Exclusive%20breaking%20news%20scene%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20style%2C%20dark%20and%20warm%20tones%2C%20professional%20photography%2C%20bold%20composition&width=900&height=700&seq=cta-exclusive-01&orientation=landscape"
          alt="独家爆料 - 911吃瓜网"
          title="911吃瓜网独家爆料"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
        <div className="absolute bottom-8 left-8">
          <span className="text-xs text-white/60 mb-2 block">独家追踪</span>
          <p className="text-xl md:text-2xl font-heading font-bold text-white max-w-xs leading-tight">
            下一个大瓜，由你来爆
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center py-14 px-8 bg-background-50 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
          有猛料？别藏着！
        </h2>
        <p className="text-sm text-foreground-500 max-w-md mb-8 leading-relaxed">
          如果你掌握了一手网红黑料、明星八卦或社会奇闻，欢迎向我们投稿。我们严格保护爆料人隐私，让你的声音被更多人听到。
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-1.5 px-6 py-3 bg-foreground-900 text-white text-sm font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          立即投稿
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>
    </section>
  );
}